<template>
  <el-dialog
      :visible="isVisible"
      @close="hide"
      :title="title"
      :destroy-on-close="true"
      :width="width"
  >
    <content-tabs
        v-if="hasConversation"
        :conversation="conversation"
        @change="hasStructuralChanges = true"
        style="margin-top: -30px"
        :index-media-url="indexMediaUrl"
        :can-create-media="canCreateMedia"
        :store-media-url="storeMediaUrl"
        :can-send-message="canSendMessage"
        :types="types"
    ></content-tabs>
    <div slot="title" class="text-uppercase font-weight-bold">{{ title }}</div>
  </el-dialog>
</template>

<script>
import eventBus from "../../../../event-bus";
import ContentTabs from './content-tabs';
import ScreenSize from '../../../../mixins/screen-size';

export default {
  components: {
    ContentTabs,
  },

  props: {
    indexMediaUrl: String,
    canCreateMedia: {
      type: Boolean,
      default: false,
    },
    storeMediaUrl: String,
    canSendMessage: {
      type: Boolean,
      default: false,
    },
    types: Object,
  },

  mixins: [
    ScreenSize,
  ],

  data() {
    return {
      isVisible: false,
      conversation: null,
      hasStructuralChanges: false,
    };
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasConversation() {
      return Boolean(this.conversation);
    },

    /**
     * @return {string}
     */
    title() {
      return _(this.conversation || {})
          .at(['contact.presentation', 'outgoing_number.presentation'])
          .join(' - ');
    },

    /**
     * @return {string}
     */
    width() {
      return this.screenSize.width > 1366 ? '1000px' : '73%';
    },
  },

  methods: {
    /**
     * @param {Object} conversation
     */
    show({conversation}) {
      this.isVisible = true;
      this.conversation = conversation;
      this.hasStructuralChanges = false;
    },

    /**
     * @return {undefined}
     */
    hide() {
      this.isVisible = false;
      this.conversation = null;
      if (this.hasStructuralChanges) {
        eventBus.$emit('send-list-items-updated');
      }
      this.hasStructuralChanges = false;
    },
  },

  created() {
    eventBus.$on('show-chat-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-chat-dialog', this.show);
  },
}
</script>
